
const loadCategories = ({ withProperties, withTopProperties, user_str_id }) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/categories', {
			headers: {Accept: 'application/json'},
			params: {
				properties: withProperties ? 'y' : null,
				top_properties: withTopProperties ? 'y' : null,
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const flatCategories = () => {
	return new Promise((resolve, reject) => {
		axios.get('/api/categories/flat', { headers: {Accept: 'application/json'} }).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const loadCategory = (slug, search, core_key, withCategory, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/category/' + slug + (core_key ? ('/' + core_key) : ''), {
			headers: {Authorization: access_token ? ('Bearer ' + access_token) : null, Accept: 'application/json'},
			params: {
				s: search ? search.replace('query-', '') : null,
				withCategory: withCategory ? 'yes' : null,
				user_str_id: user_str_id ? user_str_id : null
			}
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const categoriesByKeywords = (keywords, exclude, access_token) => {
	return new Promise((resolve, reject) => {
		axios.get('/api/category/search', {
			headers: {Authorization: access_token ? ('Bearer ' + access_token) : null, Accept: 'application/json'},
			params: { query: keywords, exclude: exclude }
		}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const mixedProperties = (list_one, list_two) => {
	var list = [...list_one]
	for(var i = 0; i < list_two.length; i ++){
		if(list_one.filter(item => item.property_id == list_two[i].property_id).length == 0){
			list.push(list_two[i]);
		}
	}
	return list
}

const toggleList = (slug, type, access_token, user_str_id) => {
	return new Promise((resolve, reject) => {
		axios.post('/api/category/' + slug + '/list/' + type + '/toggle', user_str_id ? {user_str_id: user_str_id} : {}, {
			headers: {
				Authorization: access_token ? ('Bearer ' + access_token) : null,
				Accept: 'application/json'
			}
		}).then(res => resolve(res.data), res => reject(res.response))
	})
}

const getRootCategory = category => category && category.parent_id ? category.category : category

const agreeRulesSlug = category => {
	const rootCategory = getRootCategory(category)
	return rootCategory && rootCategory.meta && rootCategory.meta.exploring_rules
}

const getCategoryProperties = category => {
	const root_properties = category && category.category && category.category.category_properties_sorted ? category.category.category_properties_sorted.map(item => item.property_id) : []
	const rootcategory_properties = category && category.category && category.category.category_properties_sorted ? category.category.category_properties_sorted : []
	const subcategory_properties = category && category.category_properties_sorted ? category.category_properties_sorted.filter(item => !root_properties.includes(item.property_id)) : []
	return [...rootcategory_properties, ...subcategory_properties]
}

const flatToTree = list => {
	var map = {}, node, roots = [], i

	for (i = 0; i < list.length; i += 1) {
		map[list[i].id] = i
		list[i].categories = []
	}

	for (i = 0; i < list.length; i += 1) {
		node = list[i]
		if (node.parent_id) {
			list[map[node.parent_id]].categories.push(node)
		} else {
			roots.push(node)
		}
	}
	return roots
}

export {
	loadCategories,
	flatCategories,
	loadCategory,
	mixedProperties,
	toggleList,
	agreeRulesSlug,
	getRootCategory,
	getCategoryProperties,
	categoriesByKeywords,
	flatToTree
}